import { render, staticRenderFns } from "./TrafficRequestDropdownNewTerms.vue?vue&type=template&id=037f9ec4&scoped=true"
import script from "./TrafficRequestDropdownNewTerms.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestDropdownNewTerms.vue?vue&type=script&lang=ts"
import style0 from "./TrafficRequestDropdownNewTerms.vue?vue&type=style&index=0&id=037f9ec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037f9ec4",
  null
  
)

export default component.exports